@let hotel = hotel$ | async;
<vp-availability-widget
	[accommodationTypes]="accommodationTypes() || hotel?.accommodationTypes"
	[bookingtoolUrl]="bookingtoolUrl"
	[currency]="currency()"
	[dealGuid]="dealGuid()"
	[defaultAdults]="defaultAdults()"
	[forceHideRangePrices]="forceHideRangePrices()"
	[hotelGuid]="hotel?.guid || hotelGuid()"
	[hotelSlug]="hotelSlug()"
	[hotels]="hotels()"
	[initialArrivalDate]="initialArrivalDate()?.toISOString()"
	[initialOccupancy]="initialOccupancy()"
	[language]="language()"
	[maxDate]="maxDate()"
	[minDate]="minDate()"
	[occupancyRestrictions]="
		occupancyRestrictions() ||
		hotel?.occupancyRestrictions ||
		defaultOccupancyRestrictions
	"
	[openAvailabilityInNewTab]="openAvailabilityInNewTab()"
	[packageGuid]="packageGuid()"
	[packages]="packages()"
	[roomGuid]="roomGuid()"
	[showAccommodationTypes]="showAccommodationTypes()"
	[showDates]="showDates()"
	[showHotels]="showHotels()"
	[showOccupancy]="showOccupancy()"
	[showPackages]="showPackages()"
	[showPrices]="showPrices()"
	[stepperConfig]="stepperConfig()"
	[useCustomEmitter]="useCustomEmitter()"
	(actionClick)="widgetCTA($event)"
	(customEmitter)="customEmitter.emit($event)"
	(packageSelected)="packageSelected.emit($event)"
>
	<ng-content />
</vp-availability-widget>
